import React from "react";
import { FaComments, FaLaptopCode, FaNetworkWired } from "react-icons/fa6";
import banner1 from "../assets/banner1.jpg";

export default function ITConsulting() {
  const features = [
    { icon: <FaComments size={20} className="text-primary" />, text: "Expert advisory on IT strategy, infrastructure, and cybersecurity." },
    { icon: <FaLaptopCode size={20} className="text-primary" />, text: "Guidance on system architecture, software development, and digital transformation." },
    { icon: <FaNetworkWired size={20} className="text-primary" />, text: "Optimized network and IT operations aligned with organizational goals." },
  ];

  return (
    <section className="MainBodySection service-detail-page">
      <div className="container service-detail-shell">
        <div className="text-center">
          <div className="section-kicker mb-3">Service Detail</div>
          <h2 className="main-section-title">IT Consulting Services</h2>
          <p className="section-copy">
            Offering expert advisory services in system architecture, digital transformation, infrastructure optimization, cybersecurity, and technology strategy aligned with organizational goals.
          </p>
        </div>

        <div className="service-detail-media">
          <img src={banner1} alt="IT Consulting Services" />
        </div>

        <div className="detail-card">
          <p className="detail-summary mb-4">
            IT consulting helps organizations make informed technology decisions that improve efficiency, security, and long-term growth.
          </p>

          <ul className="detail-feature-list mb-4">
            {features.map(item => (
              <li key={item.text} className="detail-feature-item">{item.icon}<span>{item.text}</span></li>
            ))}
          </ul>

          <ol className="detail-step-list">
            <li>Assess current IT systems and infrastructure.</li>
            <li>Provide strategic recommendations for software, hardware, and security.</li>
            <li>Develop implementation roadmaps for digital transformation initiatives.</li>
            <li>Monitor performance and advise on optimization opportunities.</li>
          </ol>
        </div>
      </div>
    </section>
  );
}